import { gql } from '@apollo/client';

export const ADDRESS_CONFIG_LIST = gql`
  query AddressConfigList($activeOnly: Boolean!) {
    addressConfigList(activeOnly: $activeOnly) {
      id
      configKey
      configValue
      description
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_ADDRESS_CONFIG = gql`
  mutation CreateAddressConfig($input: CreateAddressConfigInput!) {
    createAddressConfig(input: $input) {
      id
    }
  }
`;

export const UPDATE_ADDRESS_CONFIG = gql`
  mutation UpdateAddressConfig($id: Long!, $input: UpdateAddressConfigInput!) {
    updateAddressConfig(id: $id, input: $input) {
      id
    }
  }
`;

export const DELETE_ADDRESS_CONFIG = gql`
  mutation DeleteAddressConfig($id: Long!) {
    deleteAddressConfig(id: $id)
  }
`;

export interface AddressConfigItem {
  id: string;
  configKey: string;
  configValue: string;
  description: string | null;
  isActive: boolean;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface AddressConfigListResponse {
  addressConfigList: AddressConfigItem[];
}

export interface CreateAddressConfigInput {
  configKey: string;
  configValue: string;
  description?: string | null;
  isActive?: boolean;
}

export interface UpdateAddressConfigInput {
  configValue?: string | null;
  description?: string | null;
  isActive?: boolean | null;
}
